export const flowInitial = [
    {
        "source": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620",
        "sourceHandle": "a",
        "target": "flow_azim_nodeA_renderer_ab31466e-b772-4024-b429-09ff7fe677d9",
        "targetHandle": null,
        "id": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620>flow_azim_nodeA_renderer_ab31466e-b772-4024-b429-09ff7fe677d9",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "stroke": "black"
        },
        "markerEnd": {
            "type": "arrowclosed"
        }
    },
    {
        "source": "flow_azim_nodeA_renderer_ab31466e-b772-4024-b429-09ff7fe677d9",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "targetHandle": null,
        "id": "flow_azim_nodeA_renderer_ab31466e-b772-4024-b429-09ff7fe677d9>flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "stroke": "black"
        },
        "markerEnd": {
            "type": "arrowclosed"
        }
    },
    {
        "source": "flow_azim_nodeA_renderer_2a9e39fa-84c5-4419-a736-91234cc36c66",
        "sourceHandle": "a",
        "target": "flow_azim_nodeC_renderer_f1e50940-2975-4782-bf1b-3a85f25187ab",
        "targetHandle": null,
        "id": "flow_azim_nodeA_renderer_2a9e39fa-84c5-4419-a736-91234cc36c66>flow_azim_nodeC_renderer_f1e50940-2975-4782-bf1b-3a85f25187ab",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "stroke": "black"
        },
        "markerEnd": {
            "type": "arrowclosed"
        }
    },
    {
        "source": "flow_azim_nodeC_renderer_f1e50940-2975-4782-bf1b-3a85f25187ab",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_24bcb8e7-dcd0-4617-b6ab-2ec2cb19144f",
        "targetHandle": null,
        "id": "flow_azim_nodeC_renderer_f1e50940-2975-4782-bf1b-3a85f25187ab>flow_azim_nodeB_renderer_24bcb8e7-dcd0-4617-b6ab-2ec2cb19144f",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "stroke": "black"
        },
        "markerEnd": {
            "type": "arrowclosed"
        }
    },
    {
        "source": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "targetHandle": null,
        "id": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620>flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "stroke": "black"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_08db8631-82bf-4049-878a-06095452866e",
        "targetHandle": null,
        "id": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620>flow_azim_nodeB_renderer_08db8631-82bf-4049-878a-06095452866e",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeA_renderer_2a9e39fa-84c5-4419-a736-91234cc36c66",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620",
        "targetHandle": null,
        "id": "flow_azim_nodeA_renderer_2a9e39fa-84c5-4419-a736-91234cc36c66>flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeB_renderer_08db8631-82bf-4049-878a-06095452866e",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "targetHandle": null,
        "id": "flow_azim_nodeB_renderer_08db8631-82bf-4049-878a-06095452866e>flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeB_renderer_24bcb8e7-dcd0-4617-b6ab-2ec2cb19144f",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "targetHandle": null,
        "id": "flow_azim_nodeB_renderer_24bcb8e7-dcd0-4617-b6ab-2ec2cb19144f>flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeA_renderer_2a9e39fa-84c5-4419-a736-91234cc36c66",
        "sourceHandle": "a",
        "target": "flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92",
        "targetHandle": null,
        "id": "flow_azim_nodeA_renderer_2a9e39fa-84c5-4419-a736-91234cc36c66>flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_08db8631-82bf-4049-878a-06095452866e",
        "targetHandle": null,
        "id": "flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92>flow_azim_nodeB_renderer_08db8631-82bf-4049-878a-06095452866e",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92",
        "sourceHandle": "a",
        "target": "flow_azim_nodeC_renderer_4db066a8-1978-4c79-931a-bc8508f6a2c8",
        "targetHandle": null,
        "id": "flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92>flow_azim_nodeC_renderer_4db066a8-1978-4c79-931a-bc8508f6a2c8",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeC_renderer_f1e50940-2975-4782-bf1b-3a85f25187ab",
        "sourceHandle": "a",
        "target": "flow_azim_nodeA_renderer_ab31466e-b772-4024-b429-09ff7fe677d9",
        "targetHandle": null,
        "id": "flow_azim_nodeC_renderer_f1e50940-2975-4782-bf1b-3a85f25187ab>flow_azim_nodeA_renderer_ab31466e-b772-4024-b429-09ff7fe677d9",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeC_renderer_4db066a8-1978-4c79-931a-bc8508f6a2c8",
        "sourceHandle": "a",
        "target": "flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "targetHandle": null,
        "id": "flow_azim_nodeC_renderer_4db066a8-1978-4c79-931a-bc8508f6a2c8>flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "source": "flow_azim_nodeA_renderer_7d5fd019-09f6-44ed-9c52-e19629b22dd5",
        "sourceHandle": "a",
        "target": "flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92",
        "targetHandle": null,
        "id": "flow_azim_nodeA_renderer_7d5fd019-09f6-44ed-9c52-e19629b22dd5>flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92",
        "type": "custom",
        "animated": false,
        "data": {
            "text": "connection line text"
        },
        "style": {
            "strokeWidth": 2,
            "stroke": "#FF0072"
        },
        "markerEnd": {
            "type": "arrowclosed",
            "width": 20,
            "height": 20,
            "color": "#FF0072"
        }
    },
    {
        "id": "flow_azim_nodeA_renderer_2a9e39fa-84c5-4419-a736-91234cc36c66",
        "type": "nodeA",
        "position": {
            "x": 141.09375,
            "y": 304.01988983154297
        },
        "data": {
            "label": "Trigger"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false
    },
    {
        "id": "flow_azim_nodeB_renderer_08db8631-82bf-4049-878a-06095452866e",
        "type": "nodeB",
        "position": {
            "x": 1412.6188826660657,
            "y": 447.2441429762756
        },
        "data": {
            "label": "Action"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeA_renderer_ab31466e-b772-4024-b429-09ff7fe677d9",
        "type": "nodeA",
        "position": {
            "x": 1369.8911467099945,
            "y": -110.03585423835622
        },
        "data": {
            "label": "Trigger"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeB_renderer_715df108-f640-453d-bc86-67f071339620",
        "type": "nodeB",
        "position": {
            "x": 891.4947284527743,
            "y": -181.19155095164842
        },
        "data": {
            "label": "Action"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeB_renderer_be1c0986-4939-4f80-9785-51f126ff7b9f",
        "type": "nodeB",
        "position": {
            "x": 2154.55984578279,
            "y": 225.17591816410896
        },
        "data": {
            "label": "Action"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeB_renderer_24bcb8e7-dcd0-4617-b6ab-2ec2cb19144f",
        "type": "nodeB",
        "position": {
            "x": 845.1629355668499,
            "y": 315.2166746445513
        },
        "data": {
            "label": "Action"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeC_renderer_f1e50940-2975-4782-bf1b-3a85f25187ab",
        "type": "nodeC",
        "position": {
            "x": 835.1629355668497,
            "y": 541.2166746445513
        },
        "data": {
            "label": "Condition"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeC_renderer_5c20df41-67b7-4317-9f6e-860463760c92",
        "type": "nodeC",
        "position": {
            "x": 861.4344992909828,
            "y": 58.35446913918224
        },
        "data": {
            "label": "Condition"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeC_renderer_4db066a8-1978-4c79-931a-bc8508f6a2c8",
        "type": "nodeC",
        "position": {
            "x": 1399.9513365165903,
            "y": 177.83106520129007
        },
        "data": {
            "label": "Condition"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    },
    {
        "id": "flow_azim_nodeA_renderer_7d5fd019-09f6-44ed-9c52-e19629b22dd5",
        "type": "nodeA",
        "position": {
            "x": 63.93366858836248,
            "y": -139.7262279623593
        },
        "data": {
            "label": "Trigger"
        },
        "style": {
            "borderRadius": 6,
            "borderColor": "#1111",
            "width": null,
            "height": null
        },
        "width": 350,
        "height": 120,
        "selected": false,
        "dragging": false
    }
]